<app-notification></app-notification>
<div id="bg">
  <img src="/assets/images/login-background.png" alt="" />
  <div class="centered">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <!--UserID-->
      <div class="card">
        <h3 class="login">Forgot Password?</h3>
        <mat-form-field class="log">
          <input
            formControlName="email"
            matInput
            placeholder="Email ID"
            class="username"
            oninput="this.value = this.value.toLowerCase()"
            required
            (keydown)="onChange()"
          />

          <mat-icon matSuffix class="icon">account_circle</mat-icon>
        </mat-form-field>
        <div class="flex">
          <a class="forgot" routerLink="/login">Login</a>
        </div>
        <!--Submit-->
        <div>
          <button id="btn-primary" mat-flat-button class="submit">
            SUBMIT
          </button>
        </div>
        <div class="hint">
          <mat-hint *ngIf="hint !== ''">{{ hint }}</mat-hint>
        </div>
        <mat-error *ngIf="error !== ''" class="error">{{ error }}</mat-error>
      </div>
    </form>
  </div>
</div>
